// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProjectOutlinedSvg from "@fishx/icons-svg/es/asn/ProjectOutlined";
import FishxIcon from '../components/FishxIcon';

var ProjectOutlined = function ProjectOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ProjectOutlinedSvg
  }));
};

ProjectOutlined.displayName = 'ProjectOutlined';
export default React.forwardRef(ProjectOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ProjectOutlined.js
// module id = 3858
// module chunks = 0